import React from 'react';
import SbEditable from 'storyblok-react';
import DynamicComponent from '~/components/DynamicComponent';

export default function TwoColumns({ blok }) {
  const { className='', textCard = [], Asset = [], reverse, gap = 12 } = blok;

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div purgeclassname="pl-12 pl-16 pl-20 pl-24 -ml-12 -ml-16 -ml-20 -ml-24" />
      <section className={className}>
        <div className="container">
          <div
            className={`flex flex-wrap -ml-${gap} justify-between space-y-12 md:space-y-0 ${
              reverse && 'md:flex-row-reverse'
            }`}
          >
            <div className={`flex items-center pl-${gap} w-full md:w-1/2 justify-center `}>
              <DynamicComponent blok={textCard[0]} />
            </div>
            <div className={`flex items-center justify-center w-full pl-${gap} md:w-1/2`}>
              <DynamicComponent blok={Asset[0]} />
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  );
}
